import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
const CTA = () => {
  return <section id="oferta" className="w-full bg-[#8B4513] py-16 text-white" data-id="element-63">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-64">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-65">
          🎁 Oferta Secreta de Hoy
        </h2>
        <p className="text-xl font-medium mb-8" data-id="element-66">
          (Disponible por tiempo limitado)
        </p>
        <div className="bg-white text-[#5E4B3C] p-8 rounded-lg shadow-lg mb-8" data-id="element-67">
          <div className="flex flex-col md:flex-row items-center justify-between mb-8" data-id="element-68">
            <div className="md:w-2/3 text-left mb-6 md:mb-0 md:pr-8" data-id="element-69">
              <h3 className="text-2xl font-bold text-[#8B4513] mb-4" data-id="element-70">
                Recibe acceso inmediato al Combo Gourmet
              </h3>
              <p className="text-lg mb-2" data-id="element-71">
                ✓ 3 Ebooks principales con +250 recetas
              </p>
              <p className="text-lg mb-2" data-id="element-72">
                ✓ 10 eBooks de bonos extra sin costo adicional
              </p>
              <p className="text-lg mb-2" data-id="element-73">
                ✓ Acceso instantáneo (descarga digital)
              </p>
              <div className="flex items-center mt-6" data-id="element-74">
                <ShieldCheckIcon className="w-6 h-6 text-[#E25822] mr-2" data-id="element-75" />
                <p className="font-medium" data-id="element-76">Garantía de satisfacción 100%</p>
              </div>
            </div>
            <div className="md:w-1/3" data-id="element-77">
              <div className="bg-[#F5EBE0] p-4 rounded-lg" data-id="element-78">
                <div className="text-left mb-3 border-b border-[#D2B48C] pb-2" data-id="element-79">
                  <div className="flex justify-between" data-id="element-80">
                    <span data-id="element-81">Combo Gourmet Base:</span>
                    <span data-id="element-82">$ 32.99</span>
                  </div>
                </div>
                <div className="text-left mb-3 border-b border-[#D2B48C] pb-2" data-id="element-83">
                  <div className="flex justify-between" data-id="element-84">
                    <span data-id="element-85">10 eBooks Bonus:</span>
                    <span data-id="element-86">$ 129.98</span>
                  </div>
                </div>
                <div className="text-left mb-3 pb-2" data-id="element-87">
                  <div className="flex justify-between font-bold text-[#8B4513]" data-id="element-88">
                    <span data-id="element-89">Valor Total:</span>
                    <span data-id="element-90">$ 162.97</span>
                  </div>
                </div>
                <div className="text-center bg-[#FFF9F0] p-3 rounded-md mt-2" data-id="element-91">
                  <p className="text-3xl font-bold text-[#E25822]" data-id="element-92">Hoy solo por $9.99</p>
                  <p className="text-sm font-medium text-[#8B4513]" data-id="element-93">
                    ¡Ahorras $ 153.00 comprando hoy!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <a href="https://pay.hotmart.com/J101918467L?off=59zwd0bh&checkoutMode=10" className="inline-block bg-[#E25822] hover:bg-[#C64718] text-white font-bold py-3 px-8 rounded-lg text-lg shadow-md transition-all transform hover:scale-105 whitespace-nowrap" data-id="element-94">
            ¡Obtener Combo Completo!
          </a>
        </div>
        <p className="text-xl" data-id="element-95">
          Conviértete en la persona que hace que todos digan:
        </p>
        <p className="text-2xl font-bold mt-2 mb-8" data-id="element-96">
          "¡Wow! ¿Tú hiciste esto?"
        </p>
        <p className="text-lg" data-id="element-97">
          Haz clic ahora y siente cómo cambia todo en tu próxima reunión. Tu
          mesa se transforma. Tus invitados se sorprenden. Y tú… Recibes cada
          mirada, cada elogio, cada sonrisa.
        </p>
      </div>
    </section>;
};
export default CTA;